import { gql } from '@apollo/client';
import {
  ArticleSummary,
  MutationUpsertArticleSummaryArgs,
} from '../../../__generated__/queries-web';

export const UPSERT_ARTICLE_SUMMARY = gql`
  mutation UpsertArticleSummary(
    $where: ArticleSummaryUniqueFilterInput!
    $create: ArticleSummaryCreationInput!
    $update: ArticleSummaryUpdateInput
  ) {
    upsertArticleSummary(where: $where, create: $create, update: $update) {
      id
      status
    }
  }
`;

export interface UpsertArticleSummaryMutation {
  upsertArticleSummary: Pick<ArticleSummary, 'id' | 'status'>;
}

export type UpsertArticleSummaryMutationVariables = MutationUpsertArticleSummaryArgs;
